

import React, { useEffect, useRef, useState } from "react";
import "./testm.css";

import HomeService from "../../../Services/HomeService";

import {
  FaArrowLeft,
  FaArrowRight,
  FaStar,
} from "react-icons/fa";

import { FaQuoteRight } from "react-icons/fa";

const NewTestimonial2 = () => {

  const [index, setIndex] = useState(0);

  const [testimonials, setTestimonials] =
    useState([]);

  const intervalRef = useRef(null);

  const autoDelay = 3500;

  /* =========================
     FETCH TESTIMONIALS
  ========================= */

  const fetchTestimonials = async () => {

    try {

      const res =
        await HomeService.getTestimonial();

      console.log("testimonials", res);

      if (res?.status) {

        setTestimonials(res?.data);

      }

    } catch (error) {

      console.log(error);

    }
  };

  useEffect(() => {

    fetchTestimonials();

  }, []);

  /* =========================
     AUTOPLAY
  ========================= */

  const startAutoPlay = () => {

    if (
      intervalRef.current ||
      testimonials.length === 0
    )
      return;

    intervalRef.current = setInterval(() => {

      setIndex((prev) =>
        prev === testimonials.length - 1
          ? 0
          : prev + 1
      );

    }, autoDelay);
  };

  const stopAutoPlay = () => {

    clearInterval(intervalRef.current);

    intervalRef.current = null;
  };

  const resetAutoPlay = () => {

    stopAutoPlay();

    startAutoPlay();
  };

  useEffect(() => {

    startAutoPlay();

    return () => stopAutoPlay();

  }, [testimonials]);

  /* =========================
     NAVIGATION
  ========================= */

  const prevHandler = () => {

    resetAutoPlay();

    setIndex((prev) =>
      prev === 0
        ? testimonials.length - 1
        : prev - 1
    );
  };

  const nextHandler = () => {

    resetAutoPlay();

    setIndex((prev) =>
      prev === testimonials.length - 1
        ? 0
        : prev + 1
    );
  };

  return (

    <section className="moderntesti-main-section">

      {/* BACKGROUND BLUR */}

      <div className="moderntesti-blur-one"></div>

      <div className="moderntesti-blur-two"></div>

      <div className="moderntesti-container">

        {/* TOP */}

        <div className="moderntesti-top-wrapper">

          <span className="moderntesti-subtitle">
            Client Experiences
          </span>

          <h2 className="moderntesti-title">
            Trusted By Property Buyers
            Across India
          </h2>

        </div>

        {/* CARD */}

        <div
          className="moderntesti-card"
          onMouseEnter={stopAutoPlay}
          onMouseLeave={startAutoPlay}
        >

          {/* LEFT */}

          <div className="moderntesti-left">

            {/* IMAGE */}

            <div className="moderntesti-image-wrapper">

              {testimonials?.length > 0 &&
                testimonials[index] && (

                  <img
                    src={
                      testimonials[index]
                        .image
                    }
                    alt="testimonial"
                  />

                )}

              <div className="moderntesti-image-overlay"></div>

            </div>

            {/* USER */}

            <div className="moderntesti-user-box">

              <div className="moderntesti-stars">

                {Array.from({
                  length: 5,
                }).map((_, i) => (

                  <FaStar key={i} />

                ))}

              </div>

              {testimonials?.length > 0 &&
                testimonials[index] && (

                  <>
                    <h3>
                      {
                        testimonials[
                          index
                        ].name
                      }
                    </h3>

                    <span>
                      {
                        testimonials[
                          index
                        ].designation
                      }
                    </span>
                  </>

                )}

            </div>

          </div>

          {/* RIGHT */}

          <div className="moderntesti-right">

            <div className="moderntesti-quote-icon">

              <FaQuoteRight />

            </div>

            {testimonials?.length > 0 &&
              testimonials[index] && (

                <p className="moderntesti-description">

                  {
                    testimonials[index]
                      .heading
                  }

                </p>

              )}

            {/* CONTROLS */}

            <div className="moderntesti-controls">

              <button
                onClick={prevHandler}
                className="moderntesti-nav-btn"
              >

                <FaArrowLeft />

              </button>

              {/* PROGRESS */}

              <div className="moderntesti-progress">

                <span
                  style={{
                    width: `${
                      100 /
                      testimonials.length
                    }%`,
                    transform: `translateX(${
                      index * 100
                    }%)`,
                  }}
                ></span>

              </div>

              <button
                onClick={nextHandler}
                className="moderntesti-nav-btn"
              >

                <FaArrowRight />

              </button>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default NewTestimonial2;